
import { Component, input, output } from '@angular/core';

@Component({
    selector: 'app-person-details-dialog',
    imports: [],
    templateUrl: './person-details-dialog.component.html',
    styleUrl: './person-details-dialog.component.css'
})
export class PersonDetailsDialogComponent {

  readonly onClose = output();
  readonly request = input<any>({});

  close(){
    this.onClose.emit();
  }
  
  getFormattedPhoneNum(number) {
    number = number.replace(/\D/g, '');
    return number.replace(/(\d{1,3})(\d{1,3})(\d{1,4})/, (match, p1, p2, p3) => {
      if (p3) {
        return `(${p1}) ${p2}-${p3}`;
      } else if (p2) {
        return `(${p1}) ${p2}`;
      } else if (p1) {
        return `(${p1})`;
      }
      return number;
    });
  }

}
